import { render, staticRenderFns } from "./hub.vue?vue&type=template&id=1b4109d2"
import script from "./hub.vue?vue&type=script&lang=js"
export * from "./hub.vue?vue&type=script&lang=js"
import style0 from "./hub.vue?vue&type=style&index=0&id=1b4109d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports